module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/in-e626d1bb4e16e732e1ddf526206aefb3.svg";